import LinkButton from '../../../../components/Button/LinkButton';
import Text from '../../../../components/Text/Text';
import useTrans from '../../../../hooks/ui/useTrans';
import NavigationItem from '../../../types/NavigationItem';

import styles from './NavigationOption.module.css';

type NavigationOptionProps = {
    item: NavigationItem;
};

const NavigationOption = ({ item }: NavigationOptionProps) => {
    const trans = useTrans();

    return (
        <LinkButton
            className={styles.Root}
            variant="white"
            size="xsmall"
            href={item.url}
            fullWidth
            noRoundCorners
        >
            <Text lineHeight="small" size="large" bold noWrapping>
                {trans(item.labelKey)}
            </Text>
        </LinkButton>
    );
};

export default NavigationOption;
